import { Sparkles, Leaf, Heart, Award, Shield, Star } from "lucide-react";
import { motion } from "framer-motion";

const FEATURES = [
  { icon: Leaf, title: "Sulfate Free", desc: "Gentle, never stripping" },
  { icon: Shield, title: "Paraben Free", desc: "Clean, evidence-led" },
  { icon: Heart, title: "Cruelty Free", desc: "Tested on us, never on them" },
  { icon: Award, title: "Salon Grade Formula", desc: "Used by 1,400+ salons" },
  { icon: Sparkles, title: "All Skin Types", desc: "Dermatologist tested" },
  { icon: Star, title: "Professional Results", desc: "Editorial finish, at home" },
];

export default function WhyChoose() {
  return (
    <section className="py-24 md:py-32 bg-white" data-testid="why-choose-section">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <div className="flex items-center gap-4 justify-center mb-4">
            <span className="divider-gold" />
            <span className="overline">Why Blisson</span>
            <span className="divider-gold" />
          </div>
          <h2 className="font-serif-display text-4xl md:text-6xl tracking-tighter font-light leading-[1.05]">
            Crafted to a standard <em className="gold-text not-italic">few</em> dare to keep.
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-12 md:gap-x-10 md:gap-y-16">
          {FEATURES.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              className="text-center md:text-left"
              data-testid={`feature-${f.title.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="w-14 h-14 mx-auto md:mx-0 rounded-full border border-[#C9A961] flex items-center justify-center text-[#C9A961] mb-5">
                <f.icon size={22} strokeWidth={1.2} />
              </div>
              <h3 className="font-serif-display text-2xl mb-1">{f.title}</h3>
              <p className="text-sm text-[#5C5C5C]">{f.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
